import React from 'react';
import './RadiologyQualityCheckModal.css';

const RadiologyQualityCheckModal = ({ isOpen, onClose, qualityResult, onProceedToSignOff }) => {
  if (!isOpen || !qualityResult) return null;

  const { score, status, issues, passedChecks, canFinalize } = qualityResult;

  return (
    <div className="rad-modal-backdrop">
      <div className="rad-quality-modal">
        <div className="rad-quality-header">
          <div className="rad-quality-title-group">
            <span className="rad-quality-icon">🔍</span>
            <div>
              <h3>Radiology Report Quality Audit</h3>
              <p className="rad-quality-subtitle">Automated completeness, missing section & clinical consistency check</p>
            </div>
          </div>
          <button className="rad-quality-close" onClick={onClose}>✕</button>
        </div>

        <div className="rad-quality-body">
          <div className={`rad-quality-scorecard ${status.toLowerCase()}`}>
            <div className="rad-score-circle">
              <span className="score-num">{score}</span>
              <span className="score-lbl">Score</span>
            </div>
            <div className="rad-score-info">
              <h4>Quality Status: {status}</h4>
              <p>
                {canFinalize
                  ? 'All mandatory clinical sections are complete. The report meets organization quality guidelines for sign-off.'
                  : 'Mandatory clinical sections are incomplete. Please resolve the errors below before finalizing.'}
              </p>
            </div>
          </div>

          {issues.length > 0 && (
            <div className="rad-quality-section">
              <h5 className="rad-section-heading">Clinical Alerts & Warnings ({issues.length})</h5>
              <div className="rad-issues-list">
                {issues.map((issue, idx) => (
                  <div key={idx} className={`rad-issue-card ${issue.severity}`}>
                    <div className="issue-badge">
                      {issue.severity === 'error' && '🔴 Error'}
                      {issue.severity === 'warning' && '🟡 Warning'}
                      {issue.severity === 'info' && 'ℹ️ Notice'}
                    </div>
                    <div className="issue-details">
                      <strong>{issue.title}</strong>
                      <p>{issue.message}</p>
                      {issue.suggestion && (
                        <div className="issue-suggestion">
                          💡 <em>Recommendation: {issue.suggestion}</em>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {passedChecks && passedChecks.length > 0 && (
            <div className="rad-quality-section">
              <h5 className="rad-section-heading">Passed Validations</h5>
              <ul className="rad-passed-list">
                {passedChecks.map((pass, idx) => (
                  <li key={idx}>✅ {pass}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="rad-quality-footer">
          <button className="btn-secondary" onClick={onClose}>
            Back to Editor
          </button>
          {canFinalize && onProceedToSignOff && (
            <button className="btn-primary" onClick={onProceedToSignOff}>
              Proceed to Sign-Off & Preview
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RadiologyQualityCheckModal;
